export enum RoutingPath {
    Home = '/',
    SignIn = '/signin',
    Register = '/register',
    Overview = 'overview',
    Missings = 'missings',
    Kitchen = "kitchen",
    Candidates = "candidates",
    Settings = "settings",
}